// Redux slice quản lý khách hàng
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import { toast } from "react-toastify";

export const fetchDichVu = createAsyncThunk("dichVu/fetchDichVu", async (params = {}, { rejectWithValue }) => {
  try {
    const query = {
      size: params.size || 10,
      page: params.page || 1,
      operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
      search: params.search,
      type: "service", // Chỉ lấy dịch vụ
    };

    // chỉ thêm nếu active có giá trị khác ""
    if (params.active !== "") {
      query.active = params.active;
    }
    const res = await api.get("/product.product", { params: query });
    // Trả về cả content và totalElements để phân trang
    return res.data;
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

// Thunks for add, update, delete dich vu
export const addDichVu = createAsyncThunk("dichVu/addDichVu", async (payload, { rejectWithValue }) => {
  try {
    // Parse int trước khi gửi lên API
    const data = {
      ...payload,
      list_price: payload.list_price != null ? parseInt(payload.list_price) : payload.list_price,
      standard_price: payload.standard_price != null ? parseInt(payload.standard_price) : payload.standard_price,
    };
    const res = await api.post("/product.product", data);
    toast.success("Thêm dịch vụ thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updateDichVu = createAsyncThunk("dichVu/updateDichVu", async (payload, { rejectWithValue }) => {
  try {
    // Parse int trước khi gửi lên API
    const data = {
      ...payload,
      list_price: payload.list_price != null ? parseInt(payload.list_price) : payload.list_price,
      standard_price: payload.standard_price != null ? parseInt(payload.standard_price) : payload.standard_price,
    };
    const res = await api.put(`/product.product/${payload.id}`, data);
    toast.success("Cập nhật dịch vụ thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchDichVuById = createAsyncThunk("dichVu/fetchDichVuById", async (id, { rejectWithValue }) => {
  try {
    const res = await api.get(`/product.product/${id}`);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});


export const deleteDichVu = createAsyncThunk("dichVu/deleteDichVu", async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/product.product/${id}`);
    toast.success("Xóa dịch vụ thành công!");
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchLoaiDichVu = createAsyncThunk("dichVu/fetchLoaiDichVu", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/medeco.service.group", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
        operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
      },
    });
    // Trả về cả content và totalElements để phân trang
    return res.data.content || [];
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchDonViTinh = createAsyncThunk("dichVu/fetchDonViTinh", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/base.uom.uom", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
      },
    });
    // Trả về cả content và totalElements để phân trang
    return res.data.content || [];
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const initialState = {
  items: { content: [], totalElements: 0 },
  loaiDichVus: [],
  donViTinhs: [],
  loading: false,
  error: null,
};

const dichVuSlice = createSlice({
  name: "dichVu",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchDichVu.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDichVu.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchDichVu.rejected, (state) => {
        state.loading = false;
        // state.error = action.payload;
      });

    // Add dich vu
    builder.addCase(addDichVu.fulfilled, (state, action) => {
      state.items.content.push(action.payload);
      state.items.totalElements += 1;
    });
    // Update dich vu
    builder.addCase(updateDichVu.fulfilled, (state, action) => {
      const idx = state.items.content?.findIndex((d) => d.id === action.payload.id);
      if (idx > -1) state.items.content[idx] = { ...state.items.content[idx], ...action.payload };
    });
    // Delete dich vu
    builder.addCase(deleteDichVu.fulfilled, (state, action) => {
      state.items.content = state.items.content?.filter((d) => d.id !== action.payload);
      state.items.totalElements -= 1;
    });
    // Get loai dich vu
    builder.addCase(fetchLoaiDichVu.fulfilled, (state, action) => {
      state.loaiDichVus = action.payload;
    });
    // Get don vi tinh
    builder.addCase(fetchDonViTinh.fulfilled, (state, action) => {
      state.donViTinhs = action.payload;
    });
  },
});

export default dichVuSlice.reducer;
